//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

// Overlay offsets are generally supposed to be 8px from any given edge
// of the Media atom. For smaller images, use a 4% offset if the browser
// supports it. This means that, for example, a 100x100 image will position
// its overlays 4px from the edge as opposed to 8px.
const getPositionOffset = (
  directions: ('top' | 'right' | 'bottom' | 'left')[],
) =>
  directions
    .map(
      (d) => `
  ${d}: ${theme.spacings[2]};
  ${d}: min(${theme.spacings[2]}, 4%);
`,
    )
    .join('');

/**
 * Style mixins to aid in positioning smaller atoms in the corners of the Media atom.
 * We pull in the theme file directly to make these simple string exports.
 */
export const MediaAtomPositionMixins = {
  TopLeft: `
    position: absolute;
    ${getPositionOffset(['top', 'left'])};
  `,
  TopRight: `
    position: absolute;
    ${getPositionOffset(['top', 'right'])};
  `,
  MiddleLeft: `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${getPositionOffset(['left'])};
  `,
  Middle: `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  `,
  MiddleRight: `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${getPositionOffset(['right'])};
  `,
  BottomLeft: `
    position: absolute;
    ${getPositionOffset(['bottom', 'left'])};
  `,
  BottomMiddle: `
    position: absolute;
    ${getPositionOffset(['bottom'])};
    left: 50%;
    transform: translateX(-50%);
  `,
  BottomRight: `
    position: absolute;
    ${getPositionOffset(['bottom', 'right'])};
  `,
  Cover: `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
} as const;
